import SwishService from './Swish.service'

export default SwishService
